// Meta SEO (title, description, canonical, og, JSON-LD) condivisi tra client e pre-rendering.
import { canonicalUrl, SITE_ORIGIN, autoDescription, firstImageSrc, absoluteUrl, cleanHtml, demoteHeadings, extractFaq } from "./seo";
import { HOME_JSONLD, webPageJsonLd } from "./seoSchema";
import { HOME_TITLE, pageDescription } from "./seoDefaults";

export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/og-image.png`;
export const fixTitle = (t) => (t ? t.replace(/Accademy/g, "Academy").replace(/accademy/g, "academy") : t);

export const HOME_META = {
  title: HOME_TITLE,
  description: "JOBTIMEHR — il portale HR aziendale: buste paga, ferie, presenze, comunicazioni e servizi HR self-service in un unico posto.",
  canonical: canonicalUrl("/"),
  image: DEFAULT_OG_IMAGE,
  imageSize: [1200, 630],
  robots: null,
  jsonLd: { "ld-org": HOME_JSONLD },
};

const faqJsonLd = (faq) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faq.map((f) => ({ "@type": "Question", name: f.question, acceptedAnswer: { "@type": "Answer", text: f.answer } })),
});

export function customPageMeta(page, slug) {
  const pageTitle = fixTitle(page.title);
  const content = demoteHeadings(cleanHtml(page.content));
  const description = (page.meta_description || "").trim() || pageDescription(slug) || autoDescription(content) || "JOBTIMEHR — portale HR aziendale.";
  const title = (page.seo_title || "").trim() || `${pageTitle} — JOBTIMEHR`;
  const url = canonicalUrl(`/p/${slug}`);
  const custom = (page.og_image || "").trim();
  const img = custom || firstImageSrc(content);
  const faq = extractFaq(content);
  const jsonLd = {
    "ld-breadcrumb": {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_ORIGIN}/` },
        { "@type": "ListItem", position: 2, name: pageTitle, item: url },
      ],
    },
    "ld-webpage": webPageJsonLd({ name: pageTitle, description, url }),
  };
  if (faq.length >= 2) jsonLd["ld-faq"] = faqJsonLd(faq);
  return {
    pageTitle, title, description, canonical: url,
    image: img ? absoluteUrl(img) : DEFAULT_OG_IMAGE,
    imageSize: custom || !img ? [1200, 630] : null,
    robots: page.noindex ? "noindex, follow" : null,
    jsonLd,
  };
}
